import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../context/auth';
import moment from 'moment';
import { Col, Row, Button, Card } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
//API
import relatorio_api from '../../../../api/relatorio_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { objCampo, validarCampos, isDateOverflow, validarData } from '../../../../helpers/ValidadorDeCampos';

//Components
import TextField from '../../../../components/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { GraficoBarras } from '../components/GraficoBarras';

function initialStateFiltroRanking() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);
    return {
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(new Date()).format("YYYY-MM-DD"),
        tipoRanking: ''
    }
}
export default function RankingFiscalizacoesRelatorio() {
    const { setLoading } = useAuth();
    const navigate = useNavigate();

    //State para consultar Ranking
    const [filtroRanking, setFiltroRanking] = useState(initialStateFiltroRanking());

    //State para pegar todas as fiscalizações conforme filtro
    const [listRanking, setListRanking] = useState();

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "tipoRanking", required: true }),
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
    ]);

    const listTipoRanking = [
        { value: "Tipo de Fiscalização", label: "Tipo de Fiscalização" },
        { value: "Regional", label: "Regional" },
        { value: "Status da Fiscalização", label: "Status da Fiscalização" },
    ];

    const onChange = (e) => {
        const { name, value } = e.target;
        setFiltroRanking({
            ...filtroRanking,
            [name]: value
        })
    }

    const onChangeTipoRanking = (value, e) => {
        setFiltroRanking({
            ...filtroRanking,
            [e.name]: value ? value.value.toString() : null,
        })
    }

    const handleFiltroRankingFiscalizacoes = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(filtroRanking, campos);

        setErrors(_errors[0]);
        if (_errors[1].length > 0) return true;

        if (!validarData(filtroRanking.dataInicial)) {
            return showMessage(
                "Aviso",
                `A data início informada não é válida. Verifique o valor informado no calendário.`,
                "warning",
                null
            );
        }
        if (!validarData(filtroRanking.dataFinal)) {
            return showMessage(
                "Aviso",
                `A data final informada não é válida. Verifique o valor informado no calendário.`,
                "warning",
                null
            );
        }

        // Verifica se o período é maior que 12 meses
        if (isDateOverflow(filtroRanking.dataInicial, filtroRanking.dataFinal, 12, 'months')) {
            setErrors({ dataInicial: { message: '' }, dataFinal: { message: '' } })
            showMessage("Aviso", "A pesquisa deve ter um período máximo de 12 meses!", "warning", null)
            return
        };

        setLoading(true);
        relatorio_api.RankingFiscalizacoes(filtroRanking)
            .then(response => {
                const _listRanking = []
                response.data.map(m => {
                    _listRanking.push([m.tipoRanking, m.totalRegistro, "#3498DB"])
                })

                setListRanking(_listRanking)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));

    }
    const handleVoltar = () => {
        setListRanking(null);
    }

    if (listRanking) {
        return <GraficoBarras dados={listRanking} handleVoltar={handleVoltar} />
    }
    return <Card className='shadowFicha mainContainerFicha p-4'>
        <div className='mb-3'>
            <Button color='secondary' className='text-white' onClick={() => navigate(-1)}>
                <FontAwesomeIcon icon={faArrowLeft} />
                <span className='px-2'> Voltar </span>
            </Button>
        </div>
        <h4 className='text-secondary m-0'>Ranking de Fiscalizações</h4>
        <Row className='mt-3'>
            <Col md={12} lg={4}>
                <TextField
                    type={"select"}
                    name={"tipoRanking"}
                    label={"* Tipo de Busca"}
                    searchable
                    options={listTipoRanking}
                    onChange={onChangeTipoRanking}
                    value={
                        listTipoRanking.filter(value => value.value == filtroRanking.tipoRanking)
                            .map(v => { return { value: v.value, label: v.value } })
                    }
                    invalid={!!errors.tipoRanking}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"date"}
                    name={"dataInicial"}
                    label={"* Data Inicial"}
                    onChange={onChange}
                    value={filtroRanking.dataInicial}
                    invalid={!!errors.dataInicial}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"date"}
                    name={"dataFinal"}
                    label={"* Data Final"}
                    onChange={onChange}
                    value={filtroRanking.dataFinal}
                    invalid={!!errors.dataFinal}
                />
            </Col>
            <Col md={12} lg={2}>
                <Button
                    className='w-100 fw-bold mt-2'
                    color='info text-light'
                    onClick={handleFiltroRankingFiscalizacoes}>Gerar Gráfico</Button>
            </Col>
        </Row>
    </Card>;
}